import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { InspeccionPeriodoCamViewModel } from 'src/app/components/_mantenimiento/campanias/periodos/inspecciones/inspecciones.types';
import { EnumTwTcResultadoInspeccionCam, InspeccionUIPeriodo, TwInspeccionCamViewModel } from '../../inspeccion.types';

@Component({
    selector: 'app-inspeccion-ui-periodo-list',
    templateUrl: './inspeccion-ui-periodo-list.component.html',
    styleUrls: ['./inspeccion-ui-periodo-list.component.scss'],
})
export class InspeccionUiPeriodoListComponent implements OnChanges {
    @Input() listaInspeccionPeriodo: InspeccionPeriodoCamViewModel[];
    @Input() inspecciones: TwInspeccionCamViewModel[];
    @Input() periodoEnPlazoVigente = true;

    isCollapsedCabecera = false;

    inspeccionesUIPeriodoObligatorias: Map<number, InspeccionUIPeriodo>;
    inspeccionesUIPeriodoNoObligatorias: Map<number, InspeccionUIPeriodo>;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.listaInspeccionPeriodo?.currentValue) {
            this.initInspeccionesUIPeriodoConfiguradas();
            this.initInspeccionesUIPeriodoCumplimentadas();
        }
        if (changes?.inspecciones?.currentValue) {
            this.initInspeccionesUIPeriodoConfiguradas();
            this.initInspeccionesUIPeriodoCumplimentadas();
        }
    }

    /**
     * A partir de la lista de inspecciones configuradas para el periodo, se construyen dos tabla-hash
     * - una para las inspecciones configuradas como obligatorias y otra para las NO obligatorias.
     * Para cada una se guardará tipo, nombre y cuántas de cada tipo.
     */
    private initInspeccionesUIPeriodoConfiguradas(): void {
        this.inspeccionesUIPeriodoObligatorias = new Map<number, InspeccionUIPeriodo>();
        this.inspeccionesUIPeriodoNoObligatorias = new Map<number, InspeccionUIPeriodo>();

        this.listaInspeccionPeriodo?.forEach(inspeccionPeriodo => {
            let inspeccionUIPeriodo = new InspeccionUIPeriodo();

            if (inspeccionPeriodo?.Obligatoria) {
                if (this.inspeccionesUIPeriodoObligatorias.has(inspeccionPeriodo.IdTipoInspeccion)) {
                    inspeccionUIPeriodo = this.inspeccionesUIPeriodoObligatorias.get(inspeccionPeriodo.IdTipoInspeccion)!;
                }
                inspeccionUIPeriodo.nombre = inspeccionPeriodo.Nombre;
                inspeccionUIPeriodo.tipoInspeccion = inspeccionPeriodo.TipoInspeccion;
                inspeccionUIPeriodo.configuradas++;
                this.inspeccionesUIPeriodoObligatorias.set(inspeccionPeriodo.IdTipoInspeccion, inspeccionUIPeriodo);
            } else {
                if (this.inspeccionesUIPeriodoNoObligatorias.has(inspeccionPeriodo.IdTipoInspeccion)) {
                    inspeccionUIPeriodo = this.inspeccionesUIPeriodoNoObligatorias.get(inspeccionPeriodo.IdTipoInspeccion)!;
                }
                inspeccionUIPeriodo.configuradas++;
                inspeccionUIPeriodo.nombre = inspeccionPeriodo.Nombre;
                inspeccionUIPeriodo.tipoInspeccion = inspeccionPeriodo.TipoInspeccion;
                this.inspeccionesUIPeriodoNoObligatorias.set(inspeccionPeriodo.IdTipoInspeccion, inspeccionUIPeriodo);
            }
        });
    }

    /**
     * A partir de las tabla-hash configuradas en el método initInspeccionesUIPeriodoConfiguradas, se recorren las inspecciones de la UI y se contabiliza para
     * cada tipo (obligatorias o no), cuántas de cada tipo se han cumplimentado.
     */
    private initInspeccionesUIPeriodoCumplimentadas(): void {
        const HoyFinalDelDia = new Date();
        HoyFinalDelDia.setHours(23);
        HoyFinalDelDia.setMinutes(59);
        HoyFinalDelDia.setSeconds(59);

        this.inspecciones?.forEach(inspeccion => {
            if (
                !inspeccion ||
                (inspeccion.FechaBorrado !== null && inspeccion.FechaBorrado !== undefined) ||
                (inspeccion?.FechaCaducidad && this.periodoEnPlazoVigente ? inspeccion?.FechaCaducidad < HoyFinalDelDia : false) ||
                inspeccion?.IdResultadoInspeccionCam === EnumTwTcResultadoInspeccionCam.ID_RECHAZADA
            ) {
                // Las inspecciones borradas o rechazadas no se tienen en cuenta para el conteo
                // Se tiene en cuenta si la inspección está caducada para el conteo, mientras el periodo esté vigente.
                return;
            }

            const inspeccionUIPeriodoConfigurada = this.listaInspeccionPeriodo?.find(s => s.Id === inspeccion.IdPeriodoInspeccionCam);

            if (!inspeccionUIPeriodoConfigurada) {
                return;
            }

            let inspeccionUIPeriodo = new InspeccionUIPeriodo();

            if (inspeccionUIPeriodoConfigurada.Obligatoria) {
                if (this.inspeccionesUIPeriodoObligatorias.has(inspeccionUIPeriodoConfigurada.IdTipoInspeccion)) {
                    inspeccionUIPeriodo = this.inspeccionesUIPeriodoObligatorias.get(inspeccionUIPeriodoConfigurada.IdTipoInspeccion)!;
                }
                inspeccionUIPeriodo.cumplimentadas++;
                this.inspeccionesUIPeriodoObligatorias.set(inspeccionUIPeriodoConfigurada.IdTipoInspeccion, inspeccionUIPeriodo);
            } else {
                if (this.inspeccionesUIPeriodoNoObligatorias.has(inspeccionUIPeriodoConfigurada.IdTipoInspeccion)) {
                    inspeccionUIPeriodo = this.inspeccionesUIPeriodoNoObligatorias.get(inspeccionUIPeriodoConfigurada.IdTipoInspeccion)!;
                }
                inspeccionUIPeriodo.cumplimentadas++;
                this.inspeccionesUIPeriodoNoObligatorias.set(inspeccionUIPeriodoConfigurada.IdTipoInspeccion, inspeccionUIPeriodo);
            }
        });
    }
}
